import popMgr from '@/components/global/popMgr';
import Common from "./index.vue";



export default () => {
    return popMgr.create(Common, {  });
}